var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Box, FormControl, FormControlLabel, Switch, FormHelperText, } from "@mui/material";
import { buildFieldValidation } from "../../validators/field-components";
import CommentArea from "../common/CommentArea";
import { useElementConditions } from "../../context/FormLogicContext";
import Header from "../common/Header";
import { getCommentFieldName, getInitialValueForElement, } from "../../../../utils/forms-functions";
import { getElementValueKey } from "../../../../utils/helpers";
import { useClearInvisibleValue } from "../../hooks/useClearInvisibleValue";
var BooleanField = function (_a) {
    var element = _a.element, errors = _a.errors;
    var unregister = useFormContext().unregister;
    var valueKey = getElementValueKey(element);
    var error = errors[valueKey];
    var _b = useElementConditions(element), isVisible = _b.isVisible, isEnabled = _b.isEnabled, isInteractive = _b.isInteractive, fieldRequired = _b.isRequired;
    var validation = useMemo(function () {
        return buildFieldValidation(element, {
            isRequired: fieldRequired,
            readOnly: !isEnabled,
        });
    }, [element, fieldRequired, isEnabled]);
    var swapOrder = element.swapOrder || false;
    var valueKeys = useMemo(function () {
        return element.showCommentArea
            ? [valueKey, getCommentFieldName(valueKey)]
            : [valueKey];
    }, [valueKey, element.showCommentArea]);
    useClearInvisibleValue({
        isVisible: isVisible,
        valueKeys: valueKeys,
        unregister: unregister,
    });
    var initialValue = getInitialValueForElement(element);
    return (_jsx(_Fragment, { children: isVisible ? (_jsx(Box, __assign({ className: "component-wrapper" }, { children: _jsxs(FormControl, __assign({ component: "fieldset", error: !!error, fullWidth: true, sx: { mb: 3 } }, { children: [_jsx(Header, { element: element, error: !!error, isRequired: fieldRequired }), _jsx(Controller, { name: valueKey, defaultValue: initialValue, rules: {
                            validate: function (value) {
                                var _a;
                                var result = validation.safeParse(value);
                                if (!result.success) {
                                    return ((_a = result.error.errors[0]) === null || _a === void 0 ? void 0 : _a.message) || "Valor inválido";
                                }
                                return true;
                            },
                        }, render: function (_a) {
                            var field = _a.field;
                            var hasValueTrue = element.valueTrue !== undefined;
                            var hasValueFalse = element.valueFalse !== undefined;
                            var hasCustomValues = hasValueTrue || hasValueFalse;
                            var isCheckedLogically;
                            if (hasCustomValues) {
                                if (hasValueTrue && hasValueFalse) {
                                    isCheckedLogically = field.value === element.valueTrue;
                                }
                                else if (hasValueTrue) {
                                    isCheckedLogically = field.value === element.valueTrue;
                                }
                                else {
                                    isCheckedLogically =
                                        field.value !== undefined &&
                                            field.value !== null &&
                                            field.value !== element.valueFalse;
                                }
                            }
                            else {
                                isCheckedLogically = Boolean(field.value);
                            }
                            var visualChecked = swapOrder
                                ? !isCheckedLogically
                                : isCheckedLogically;
                            var label;
                            if (visualChecked) {
                                // Quando o switch está "ligado"
                                if (swapOrder) {
                                    label = element.labelFalse || "Não";
                                }
                                else {
                                    label = element.labelTrue || "Sim";
                                }
                            }
                            else {
                                // Quando o switch está "desligado"
                                if (swapOrder) {
                                    label = element.labelTrue || "Sim";
                                }
                                else {
                                    label = element.labelFalse || "Não";
                                }
                            }
                            return (_jsx(FormControlLabel, { control: _jsx(Switch, { checked: visualChecked, onChange: function (e) {
                                        var _a, _b;
                                        var logicalChecked = swapOrder
                                            ? !e.target.checked
                                            : e.target.checked;
                                        var newValue;
                                        if (hasCustomValues) {
                                            newValue = logicalChecked
                                                ? (_a = element.valueTrue) !== null && _a !== void 0 ? _a : true
                                                : (_b = element.valueFalse) !== null && _b !== void 0 ? _b : false;
                                        }
                                        else {
                                            newValue = logicalChecked;
                                        }
                                        field.onChange(newValue);
                                    }, disabled: !isInteractive }), label: label }));
                        } }), error && (_jsx(FormHelperText, { children: error.message })), element.showCommentArea && (_jsx(CommentArea, { element: element, disabled: !isInteractive }))] })) }))) : null }));
};
export default BooleanField;
